import { render, staticRenderFns } from "./asigLeechero.vue?vue&type=template&id=f15268c2&"
import script from "./asigLeechero.vue?vue&type=script&lang=js&"
export * from "./asigLeechero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports